export default __webpack_public_path__ + "static/media/Background_00246.4d365b6b.png";